module.exports = __webpack_public_path__ + "img/nav-recordings.132621a6.svg";